import xss from "xss";

export default class PageStorage {
  constructor(props = {}) {
    let { pageNumber, visiblePage } = props;
    this.pageNumber = !isNaN(pageNumber) ? pageNumber : 0;
    this.visiblePage = visiblePage || 'overview';
    this.message = "";
    this.refresh = false;
    this.delta = false;
  }

  setPageNumber(number) {
    this.pageNumber = Number(number);
  }

  getPageNumber() {
    return this.pageNumber;
  }

  setPage(pageName) {
    this.visiblePage = xss(pageName);
  }

  setMessage(text) {
    this.message = xss(text);
  }

  setRefresh(flag) {
    this.refresh = !!flag;
  }

  setDeltaError(text) {
    if(text) {
      this.delta = true;
      this.message = text;
    }
  }

  isVisible(pageName) {
    return this.visiblePage === xss(pageName);
  }

  isErrorPage() {
    return this.visiblePage === 'error';
  }

  isDeltaErrorPage() {
    return this.visiblePage === 'deltaError' || this.delta;
  }

  isAdminPage() {
    return this.visiblePage === 'admin';
  }
}
